'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { Hu, Wu, Uu, Ku, qu, Ju, AudioWaveform } from './product-page';
import { $l, MarketPrompt, MarketImage, MarketFile } from './market-primitives';
import { U, MarketReveal } from './collection-animation';
import { BlurSwap, ShowcaseSpinner } from './playback-controls';
import { ShowcaseIcon } from './scene-primitives';
export function ProductVideo({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = e >= Hu.ready,
    n = $l(e, Hu.play, Hu.play + Wu),
    r = Math.floor(n * Uu),
    i = e >= Hu.play && n < 1,
    a = Ku[Math.min(Ku.length - 1, Math.floor(n * Ku.length))] ?? '';
  return (
    <div className={'flex flex-col gap-4'}>
      <MarketPrompt
        t={e}
        workflow={'Create a Product Video'}
        brand={'aubrac'}
        prompt={`${U.ref}, 15 seconds, with sound`}
        doneAt={Hu.ready}
        busy={'Making the product video'}
        result={'Product video ready'}
        meta={'0:15 \xB7 with sound'}
      />
      <div className={'grid gap-3 lg:grid-cols-[minmax(0,1fr)_288px] lg:gap-4'}>
        <MarketReveal on={e >= Hu.frame} className={'mk-card p-2'}>
          <div
            className={
              'relative aspect-[16/8] overflow-hidden rounded-[8px] bg-[#1d1a18] sm:aspect-[16/7]'
            }
          >
            {translateShowcaseNode(
              showcaseCopy,
              qu.map((e, r) => {
                let i =
                    r === Math.min(qu.length - 1, Math.floor(n * qu.length)),
                  a = $l(n, r / qu.length, (r + 1) / qu.length);
                return (
                  <span
                    key={e.asset.src}
                    className={
                      'absolute inset-0 transition-opacity duration-500'
                    }
                    style={{
                      opacity: +!!i,
                    }}
                  >
                    <MarketImage
                      asset={e.asset}
                      focus={e.focus}
                      className={'size-full'}
                      imgStyle={{
                        transform: `scale(${1.04 + a * 0.08})`,
                        transformOrigin: e.focus,
                        filter: t ? 'none' : 'blur(10px) saturate(0.6)',
                        transition: 'filter 600ms var(--ease)',
                      }}
                    />
                  </span>
                );
              })
            )}
            <span
              className={
                'mk-serif pointer-events-none absolute inset-0 grid place-items-center px-6 text-center text-[26px] leading-tight text-white transition-opacity duration-300 sm:text-[40px]'
              }
              style={{
                opacity: +!!i,
                textShadow: '0 1px 12px rgb(0 0 0 / 0.35)',
              }}
            >
              <BlurSwap value={a} />
            </span>
            <span
              className={
                'absolute inset-0 grid place-items-center text-white transition-opacity duration-300'
              }
              style={{
                opacity: +!t,
              }}
            >
              <span
                className={
                  'flex items-center gap-2 rounded-full bg-black/45 px-3 py-1.5 text-[12px] font-medium backdrop-blur-sm'
                }
              >
                <ShowcaseSpinner className={'size-3.5'} />
                {translateShowcaseNode(showcaseCopy, 'Rendering')}
              </span>
            </span>
          </div>
          <div className={'flex items-center gap-2 px-1 pt-2'}>
            <span className={'text-ink grid size-8 place-items-center'}>
              <ShowcaseIcon name={i ? 'pause' : 'play'} className={'size-4'} />
            </span>
            <span className={'num text-ink-3 w-[74px] shrink-0 text-[12px]'}>
              {translateShowcaseNode(showcaseCopy, Ju(r))}
              {translateShowcaseNode(showcaseCopy, ' / ')}
              {translateShowcaseNode(showcaseCopy, Ju(Uu))}
            </span>
            <span
              className={
                'relative h-1 flex-1 overflow-hidden rounded-full bg-[var(--state-wash)]'
              }
            >
              <span
                className={
                  'absolute inset-0 origin-left rounded-full bg-[var(--primary)]'
                }
                style={{
                  transform: `scaleX(${n})`,
                }}
              />
            </span>
            <span
              className={'text-ink-3 flex items-center gap-1 pl-1 text-[12px]'}
            >
              <ShowcaseIcon name={'speaker'} className={'size-4'} />
              <span className={'max-sm:sr-only'}>
                {translateShowcaseNode(showcaseCopy, 'Sound on')}
              </span>
            </span>
          </div>
          <div className={'px-1 pt-1 pb-1'}>
            <AudioWaveform played={n} on={t} />
          </div>
        </MarketReveal>
        <div className={'flex flex-col gap-3'}>
          <MarketFile
            on={e >= Hu.files}
            name={'aubrac-coat-dress-16x9.mp4'}
            kind={'16:9 \xB7 0:15 \xB7 with sound'}
            icon={'play'}
            thumb={
              <MarketImage
                asset={U.kit.teaser}
                focus={'50% 32%'}
                className={'absolute! inset-0'}
              />
            }
          />
          <MarketFile
            on={e >= Hu.files}
            delay={90}
            name={'aubrac-coat-dress-9x16.mp4'}
            kind={'9:16 \xB7 0:15 \xB7 with sound'}
            icon={'play'}
            thumb={
              <MarketImage
                asset={U.kit.launch}
                focus={'50% 30%'}
                className={'absolute! inset-0'}
              />
            }
          />
          <MarketReveal
            on={e >= Hu.files + 300}
            className={'text-ink-3 px-1 text-[12px] leading-5'}
          >
            {translateShowcaseNode(
              showcaseCopy,
              'Two cuts, saved to your workspace for review.'
            )}
          </MarketReveal>
        </div>
      </div>
    </div>
  );
}
export const Zu = {
  card: 200,
  items: 500,
  actions: 1100,
  cursorIn: 1700,
  cursorAim: 2e3,
  press: 3e3,
  decide: 3160,
  cursorOut: 3500,
};
export const Qu = [
  {
    name: 'Product page and 6 listing images',
    short: 'Product page',
    to: 'Store',
    icon: 'store',
    asset: U.image,
    zoom: 1,
    focus: '50% 40%',
  },
  {
    name: 'Campaign kit: teaser, launch, last call',
    short: 'Campaign kit',
    to: 'Social account',
    icon: 'megaphone',
    asset: U.kit.teaser,
    zoom: 1.45,
    focus: '37% 48%',
  },
  {
    name: 'Product video, with sound',
    short: 'Video',
    to: 'Social account',
    icon: 'play',
    asset: U.kit.detail,
    zoom: 1,
    focus: '50% 45%',
  },
];
export const $u = {
  approved: {
    icon: 'check',
    line: 'Approved. Scheduled for release.',
    toast: {
      id: 'approved',
      title: 'Approved \xB7 scheduled for launch',
      meta: 'Store and social account',
      icon: 'clock',
    },
  },
  edit: {
    icon: 'pen',
    line: 'Opened for edits. Nothing went out.',
    toast: {
      id: 'edit',
      title: 'Opened for edits',
      meta: 'Nothing was published',
      icon: 'pen',
    },
  },
  declined: {
    icon: 'x',
    line: 'Declined. Nothing went out.',
    toast: {
      id: 'declined',
      title: 'Kept as a draft',
      meta: 'Nothing was published',
      icon: 'x',
    },
  },
};
export const ed = {
  id: 'ready',
  title: 'Launch kit ready',
  meta: 'Waiting for your approval',
  icon: 'doc',
};
export function PublishIllustration({ t: e }) {
  let t = e >= Zu.cursorIn && e < Zu.cursorOut,
    n = e >= Zu.cursorAim,
    r = e >= Zu.press && e < Zu.decide;
  return (
    <span
      aria-hidden={!0}
      className={
        'mk-cursor pointer-events-none absolute top-[58%] left-[56%] z-10'
      }
      style={{
        opacity: +!!t,
        transform: n ? 'none' : 'translate(70px, 64px)',
      }}
    >
      <svg
        viewBox={'0 0 24 24'}
        className={
          '-mt-[3px] -ml-[5px] size-[22px] origin-top-left drop-shadow-[0_2px_3px_rgb(0_0_0/0.25)] transition-transform duration-[120ms]'
        }
        style={{
          transform: r ? 'scale(0.84)' : 'none',
        }}
      >
        <path
          d={'M5 3.2v15.6l4.1-3.9 2.6 6 2.7-1.2-2.6-5.9h5.7z'}
          fill={'#0d0d0d'}
          stroke={'#fff'}
          strokeWidth={'1.4'}
          strokeLinejoin={'round'}
        />
      </svg>
    </span>
  );
}
export function ImaiLogo({ className: e = '' }) {
  return (
    <svg
      viewBox={'0 0 199 148.82'}
      aria-hidden={!0}
      className={e}
      fill={'currentColor'}
    >
      <path
        d={
          'M74.54 31.19c1.47,-3.44 3.86,-4.97 7.36,-4.97 3.44,0 5.84,1.53 7.13,4.97l44.39 117.63 28.36 0 -49.36 -129.97c-5.22,-13.63 -15.17,-18.85 -30.33,-18.85 -15.35,0 -25.36,5.22 -30.76,18.85l-51.33 129.97 28.18 0 46.36 -117.63z'
        }
      />
      <path
        d={
          'M111.76 31.19c1.47,-3.44 3.86,-4.97 7.36,-4.97 3.44,0 5.84,1.53 7.12,4.97l44.39 117.63 28.37 0 -49.36 -129.97c-5.22,-13.63 -15.17,-18.85 -30.33,-18.85 -15.35,0 -25.36,5.22 -30.76,18.85l-51.33 129.97 28.18 0 46.36 -117.63z'
        }
      />
    </svg>
  );
}
export const Scene_a = ImaiLogo;
